import RejectedApplications from "../Administration/RejectedApplications";

const FireRejectedApplications = ({ role }) => {
  return (
    <>
      <RejectedApplications role={role} />
    </>
  );
};

export default FireRejectedApplications;
